import React, { useEffect, useState, useCallback } from 'react';
import { Box, Button, Grid, Card, CardContent, Drawer, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { token } from '../../../../api';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import InboxIcon from '@mui/icons-material/MoveToInbox';

import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import StarBorder from '@mui/icons-material/StarBorder';

import AppSettings from './ajustes/AppSettings';
// import SwitchboardNew from '../configuracoes/Switchboards/SwitchboardNew';
// import SwitchboardIntegrationNew from '../configuracoes/Switchboards/SwitchboardIntegration';

import CriaPipeline from '../../pipeline/CriaPipeline';
// import CriaStage from '../configuracoes/stages/CriaStage';

import ViewUsersSystem from '../configuracoes/users/ViewUsersSystem';
import CreateUserSystem from '../configuracoes/users/CreateUserSystem';

import CustomizedSteppers from './ajustes/AppKeys';

const API_BASE = process.env.REACT_APP_BACKEND_SERVER || 'http://127.0.0.1:9000';
const getAuthHeader = () => ({ Authorization: `Token ${localStorage.getItem('authToken')}` });

const useStyles = makeStyles((theme) => ({
    searchControl: {
        width: '680px',
        marginLeft: '4px',
        marginBottom: '8px',
        background: '#fff',
        [theme.breakpoints.down('lg')]: { width: '100%' }
    },
    popperResults: {
        position: 'absolute',
        zIndex: 2000,
        width: '630px',
        backgroundColor: '#fff',
        boxShadow: theme.shadows[3],
        maxHeight: '250px',
        overflowY: 'auto',
        borderRadius: '8px',

        // novo:
        top: '250px',
        left: '300px',
        right: 0
    },
    listItemHover: {
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
            cursor: 'pointer'
        }
    }
}));

const SettingsControl = () => {
    const [drawerOpen, setDrawerOpen] = useState(true);
    const [open1, setOpen1] = React.useState(false);
    const [open2, setOpen2] = React.useState(false);
    const [open3, setOpen3] = React.useState(false);
    const [open4, setOpen4] = React.useState(false);
    const [open5, setOpen5] = React.useState(false);
    // const [open4, setOpen4] = React.useState(false);

    const [openDrawerGeral, setopenDrawerGeral] = React.useState(false);
    const [openDrawerChavesApp, setopenDrawerChavesApp] = React.useState(false);
    const [openDrawerIntegra, setopenDrawerIntegra] = React.useState(false);
    const [openDrawerWebhook, setopenDrawerWebhook] = React.useState(false);
    const [openDrawerSwitch, setopenDrawerSwitch] = React.useState(false);
    const [openDrawerFluxo, setopenDrawerFluxo] = React.useState(false);
    const [openDrawerUsuarios, setopenDrawerUsuarios] = React.useState(false);

    //-------------------------------------------------------
    const [activeDrawer, setActiveDrawer] = useState(null);

    const openDrawer = (drawerName) => {
        setActiveDrawer(drawerName);
    };

    const closeDrawer = () => {
        setActiveDrawer(null);
    };

    //-------------------------------------------------------

    const handleClick1 = () => {
        setOpen1(!open1);
        setOpen2(false);
        setOpen3(false);
        setOpen4(false);
        setOpen5(false);
    };

    const handleClick2 = () => {
        setOpen2(!open2);
        setOpen1(false);
        setOpen3(false);
        setOpen4(false);
        setOpen5(false);
    };

    const handleClick3 = () => {
        setOpen3(!open3);
        setOpen1(false);
        setOpen2(false);
        setOpen4(false);
        setOpen5(false);
    };

    const handleClick4 = () => {
        setOpen4(!open4);
        setOpen1(false);
        setOpen2(false);
        setOpen3(false);
        setOpen5(false);
    };

    const handleClick5 = () => {
        setOpen4(false);
        setOpen1(false);
        setOpen2(false);
        setOpen3(false);
        setOpen5(!open5);
    };

    return (
        <Box gap={2} sx={{ height: '100%', width: '100%', p: 0.1 }}>
            <Card>
                <Box sx={{ flex: 9, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                    <Typography variant="h2" sx={{ marginTop: 5, marginLeft: 5, mb: 2, width: '300px' }}>
                        Configurações
                    </Typography>
                </Box>
            </Card>

            <List
                sx={{ width: '100%', bgcolor: 'background.paper' }}
                component="nav"
                aria-labelledby="nested-list-subheader"
                // subheader={
                //     <ListSubheader component="div" id="nested-list-subheader">
                //         Configurações
                //     </ListSubheader>
                // }
            >
                <ListItemButton onClick={handleClick5} sx={{ marginTop: 1 }}>
                    <ListItemIcon>
                        <InboxIcon />
                    </ListItemIcon>
                    <ListItemText primary="Usuários do sistema" />
                    {open5 ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={open5} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding onClick={() => openDrawer('visualizarUsuarios')}>
                        <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                                <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="Visualizar usuários" />
                        </ListItemButton>
                    </List>
                    <List component="div" disablePadding onClick={() => openDrawer('criarUsuarios')}>
                        <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                                <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="Criar usuário" />
                        </ListItemButton>
                    </List>
                </Collapse>
                <ListItemButton onClick={handleClick1} sx={{ marginTop: 1 }}>
                    <ListItemIcon>
                        <InboxIcon />
                    </ListItemIcon>
                    <ListItemText primary="Aplicação" />
                    {open1 ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={open1} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding onClick={() => openDrawer('geral')}>
                        <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                                <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="Geral" />
                        </ListItemButton>
                    </List>
                    <List component="div" disablePadding onClick={() => openDrawer('chaves')}>
                        <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                                <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="Chaves da Aplicação" />
                        </ListItemButton>
                    </List>
                </Collapse>
                <ListItemButton onClick={handleClick2} sx={{ marginTop: 1 }}>
                    <ListItemIcon>
                        <InboxIcon />
                    </ListItemIcon>
                    <ListItemText primary="Canais" />
                    {open2 ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={open2} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding onClick={() => openDrawer('app')}>
                        <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                                <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="App" />
                        </ListItemButton>
                    </List>
                    <List component="div" disablePadding onClick={() => openDrawer('switchboards')}>
                        <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                                <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="Switchboards" />
                        </ListItemButton>
                    </List>
                    <List component="div" disablePadding onClick={() => openDrawer('switchboardsIntegration')}>
                        <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                                <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="Switchboard Integration" />
                        </ListItemButton>
                    </List>
                    <List component="div" disablePadding onClick={() => openDrawer('webhooks')}>
                        <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                                <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="Webhooks" />
                        </ListItemButton>
                    </List>
                </Collapse>
                <ListItemButton onClick={handleClick3} sx={{ marginTop: 1 }}>
                    <ListItemIcon>
                        <InboxIcon />
                    </ListItemIcon>
                    <ListItemText primary="Roteamento" />
                    {open3 ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={open3} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding onClick={() => openDrawer('fluxo')}>
                        <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                                <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="Fluxo de Mensagens" />
                        </ListItemButton>
                    </List>
                </Collapse>
                <ListItemButton onClick={handleClick4} sx={{ marginTop: 1 }}>
                    <ListItemIcon>
                        <InboxIcon />
                    </ListItemIcon>
                    <ListItemText primary="Negócio" />
                    {open4 ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={open4} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding onClick={() => openDrawer('pipeline')}>
                        <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                                <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="Pipeline" />
                        </ListItemButton>
                    </List>
                    <List component="div" disablePadding onClick={() => openDrawer('stage')}>
                        <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                                <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="Fases" />
                        </ListItemButton>
                    </List>
                </Collapse>
            </List>

            <Drawer anchor="right" open={Boolean(activeDrawer)} onClose={closeDrawer} PaperProps={{ sx: { width: '50vw' } }}>
                <Box sx={{ width: '50vw', p: 0 }}>
                    {activeDrawer === 'visualizarUsuarios' && <ViewUsersSystem onClose={closeDrawer} />}
                    {activeDrawer === 'criarUsuarios' && <CreateUserSystem onClose={closeDrawer} />}
                    {activeDrawer === 'geral' && <Typography>Geral</Typography>}
                    {activeDrawer === 'chaves' && <CustomizedSteppers />}
                    {activeDrawer === 'app' && <AppSettings onClose={closeDrawer} />}
                    {/* {activeDrawer === 'switchboards' && <SwitchboardNew onClose={closeDrawer} />}
                    {activeDrawer === 'switchboardsIntegration' && <SwitchboardIntegrationNew onClose={closeDrawer} />} */}
                    {activeDrawer === 'webhooks' && <Typography>Webhooks</Typography>}
                    {activeDrawer === 'fluxo' && <Typography>Fluxo de Mensagens</Typography>}
                    {activeDrawer === 'pipeline' && <CriaPipeline />}
                    {/* {activeDrawer === 'stage' && <CriaStage />} */}
                </Box>
            </Drawer>
        </Box>
    );
};

export default SettingsControl;
